import { requestJson } from "../lib/api";

export function getPredictionAuditMeta() {
  return requestJson("/api/admin/prediction-audits/meta");
}

export function getPredictionAudit(params = {}) {
  const searchParams = new URLSearchParams();

  if (params.page != null) {
    searchParams.set("page", String(params.page));
  }

  if (params.pageSize != null) {
    searchParams.set("pageSize", String(params.pageSize));
  }

  if (params.userId) {
    searchParams.set("userId", params.userId);
  }

  if (params.fixtureId) {
    searchParams.set("fixtureId", params.fixtureId);
  }

  const query = searchParams.toString();

  return requestJson(`/api/admin/prediction-audits${query ? `?${query}` : ""}`);
}
